import React, { useContext, useEffect, useMemo, useState } from 'react';
import CardBox from '../CardBox';
import { useRequest } from 'ahooks';
import styles from './index.module.scss';
import device_rank_icon from '../../imgs/device_rank_icon.png';
import { EchartsWithTheme, Empty, Tooltip, useTheme } from '@maxtropy/components';
import { getChartOption } from './charts';
import { Progress, Spin } from 'antd';
import classNames from 'classnames';
import { keepZeroOrLine } from '@/utils/utils';
import { AlarmRecordsAnalysisContext } from '../..';
import { apiV2AlarmRecordAnalysisAreaAlarmRankingPost } from '@maxtropy/device-customer-apis-v2';
import { getDefaultTime } from '../../utils';
import { DateType } from '../../const';

const EachAreaAlarmRanking = () => {
  const {
    timeResolution,
    value,
    activeKey,
    selectedSceneId,
    setAlarmModalOpen,
    setSearchParams,
    searchParams,
    sceneTabList,
  } = useContext(AlarmRecordsAnalysisContext);
  const theme = useTheme();
  const [selectedId, setSelectedId] = useState<number>();

  // 区域报警排名
  const { data: alarmRankingData, loading } = useRequest(
    async () => {
      return await apiV2AlarmRecordAnalysisAreaAlarmRankingPost({
        sceneId: selectedSceneId,
        startTime: getDefaultTime(timeResolution!, value?.[0]).startTime,
        endTime: getDefaultTime(timeResolution!, value?.[1]).endTime,
        timeResolution: timeResolution === DateType.CUSTOM ? 'D' : timeResolution,
        state: activeKey === 'all' ? undefined : activeKey,
      });
    },
    {
      ready: !!timeResolution && !!value && !!activeKey,
      refreshDeps: [timeResolution, selectedSceneId, value, activeKey],
    }
  );

  useEffect(() => {
    if (!alarmRankingData?.list?.[0]) return;
    setSelectedId(alarmRankingData?.list?.[0]?.labelId);
  }, [alarmRankingData]);

  const selecedChartData = useMemo(() => {
    return alarmRankingData?.list?.find(item => item.labelId === selectedId);
  }, [alarmRankingData, selectedId]);

  // 图表
  const lineChartOption = useMemo(() => {
    return getChartOption(selecedChartData?.detail, selecedChartData?.labelName);
  }, [alarmRankingData, selecedChartData]);

  const total = useMemo(() => {
    return (alarmRankingData?.list ?? []).reduce((sum, item) => sum + (item?.count ?? 0), 0);
  }, [alarmRankingData]);

  return (
    <CardBox title="各区域报警排名">
      <Spin spinning={loading}>
        {!alarmRankingData?.list || alarmRankingData?.list?.length === 0 ? (
          <Empty />
        ) : (
          <>
            <div className={styles.top_rank_list_wrapper}>
              {(alarmRankingData?.list ?? []).map((item, index) => (
                <div
                  onMouseEnter={() => setSelectedId(item.labelId)}
                  className={classNames(styles.top_rank_list_item, selectedId === item.labelId ? styles.selected : '')}
                  key={item.labelId}
                  onClick={() => {
                    setSelectedId(item.labelId);
                    setSearchParams?.({
                      ...searchParams,
                      startTime: getDefaultTime(timeResolution!, value?.[0]).startTime,
                      endTime: getDefaultTime(timeResolution!, value?.[1]).endTime,
                      areaLabelId: item.labelId,
                      deviceLabelIds: selectedSceneId ? [selectedSceneId] : (sceneTabList ?? []).map(i => i.id!),
                    });
                    setAlarmModalOpen?.(true);
                  }}
                >
                  <span className={styles.rank_num}>{index + 1}</span>
                  <img className={styles.rank_icon} src={device_rank_icon} alt="" />
                  <Tooltip title={item.labelName}>
                    <span className={styles.device_name}>{item.labelName}</span>
                  </Tooltip>
                  <div className={styles.progress}>
                    <Progress
                      percent={total === 0 ? 0 : ((item.count ?? 0) / total) * 100}
                      showInfo={false}
                      size="small"
                      strokeColor={'#FF4D4F'}
                    />
                  </div>
                  <span className={styles.alarm_num}>{item.count}</span>
                </div>
              ))}
            </div>
            <div className={styles.bottom_bar_wrapper}>
              <div className={styles.bottom_count}>
                <div className={styles.label}>{selecedChartData?.labelName + '-报警趋势'}</div>
                <div className={styles.count}>
                  总计(次)：<span className={styles.count_num}>{keepZeroOrLine(selecedChartData?.count)}</span>
                </div>
              </div>
              <EchartsWithTheme
                empty={{
                  isShowEmpty: !alarmRankingData,
                  emptyNode: <Empty />,
                }}
                loading={loading}
                theme={theme}
                style={{ height: 160 }}
                option={lineChartOption}
              />
            </div>
          </>
        )}
      </Spin>
    </CardBox>
  );
};

export default EachAreaAlarmRanking;
